import type { SettingsMenuItem } from "@/components/user-management/SettingsLayout";

/**
 * The settings screens this console has that the fleet's module does not.
 *
 * Passed to `SettingsLayout` through `additionalMenuItems` — the extension
 * point the fleet's own app uses — rather than added to the menu inside the
 * copied component. Editing the copy to add our screen is how it drifts one
 * reasonable change at a time, and the prop exists for exactly this
 * ([MEM-130]: mutate the pair, not the copy).
 *
 * Written once here because every settings screen has to show the same menu:
 * a list built at each route is a menu that loses an entry on the screen
 * somebody forgot to update, and nothing fails.
 */
const CONNECTED_APPLICATIONS_ITEM: SettingsMenuItem = {
  id: "connected-applications",
  label: "Connected Applications",
  to: "/settings/connected-applications",
};

/**
 * The menu items this console adds, in the order they are shown.
 *
 * A function of `workspaceId` rather than a plain constant — unlike
 * `connected-applications`, `members` is addressed by workspace
 * (`sitebrew-api#252`, M3 of design note 0001, the same reason `api-tokens`
 * is): who belongs to a workspace is a fact about that one workspace, so the
 * link has to name it the way `SettingsLayout`'s own base `api-tokens` item
 * already does from its `workspaceId` prop.
 */
export const ourSettingsItems = (workspaceId: string): SettingsMenuItem[] => [
  { id: "members", label: "Members", to: `/workspaces/${workspaceId}/settings/members` },
  CONNECTED_APPLICATIONS_ITEM,
];
